import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConfiguration } from '@klubovna/api-client';
import {
  rewardsControllerCreate,
  RewardsControllerCreate$Params,
  rewardsControllerDelete,
  rewardsControllerFindAll,
  RewardsControllerFindAll$Params,
  rewardsControllerUpdate,
  RewardsControllerUpdate$Params,
} from '@klubovna/api-client';
import { CreateRewardDto, Reward, UpdateRewardDto } from '@klubovna/api-client';
import { PaginatedResponse, toPaginatedResponse } from '@klubovna/api-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface RewardsQueryParams {
  page?: number;
  limit?: number;
  search?: string;
  isActive?: boolean;
  sortBy?: 'createdAt' | 'name' | 'costPoints';
  sortOrder?: 'ASC' | 'DESC';
}

@Injectable({
  providedIn: 'root',
})
export class RewardsApiService {
  private http = inject(HttpClient);
  private apiConfig = inject(ApiConfiguration);

  findAll(params?: RewardsQueryParams): Observable<PaginatedResponse<Reward>> {
    const apiParams: RewardsControllerFindAll$Params = {
      page: params?.page,
      limit: params?.limit,
      search: params?.search,
      isActive: params?.isActive,
      sortBy: params?.sortBy,
      sortOrder: params?.sortOrder,
    };

    return rewardsControllerFindAll(this.http, this.apiConfig.rootUrl, apiParams)
      .pipe(map(response => toPaginatedResponse<Reward>(response.body)));
  }

  create(rewardData: CreateRewardDto): Observable<Reward> {
    const params: RewardsControllerCreate$Params = {
      body: rewardData,
    };
    return rewardsControllerCreate(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => response.body as Reward));
  }

  update(id: string, rewardData: UpdateRewardDto): Observable<Reward> {
    const params: RewardsControllerUpdate$Params = {
      id,
      body: rewardData,
    };
    return rewardsControllerUpdate(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => response.body as Reward));
  }

  delete(id: string): Observable<void> {
    return rewardsControllerDelete(this.http, this.apiConfig.rootUrl, { id })
      .pipe(map(() => undefined));
  }
}
